(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/several-rounds-sport.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/several-rounds-sport.js');

'use strict';

svs.game_results.models.SeveralRoundsSport = Backbone.Model.extend({
  initialize(options) {
    this.set('productName', options.product);
  },
  getGameResult() {
    const productName = this.get('productName');
    const openRounds = svs.game_results.data ? svs.game_results.data[productName] : '';
    let combinedRounds = [];
    let roundsToFetch;
    const liveRounds = openRounds.resultDates.filter(round => round.drawStateId >= svs.game_results.constants.drawStates.CLOSED && round.drawStateId < svs.game_results.constants.drawStates.FINALIZED);
    if (liveRounds.length > 0) {
      const lastLiveRound = liveRounds[liveRounds.length - 1];
      combinedRounds = openRounds.resultDates.filter(round => dateFns.isSameDay(new Date(lastLiveRound.date), new Date(round.date)));

      combinedRounds = combinedRounds.concat(liveRounds);

      roundsToFetch = _.uniq(combinedRounds, item => item.drawNumber);
    } else {
      const finalizedRounds = openRounds.resultDates.filter(round => round.drawStateId === svs.game_results.constants.drawStates.FINALIZED);
      const lastFinalizedRound = finalizedRounds.length > 0 ? finalizedRounds[finalizedRounds.length - 1] : null;
      if (lastFinalizedRound) {
        roundsToFetch = openRounds.resultDates.filter(round => dateFns.isSameDay(new Date(lastFinalizedRound.date), new Date(round.date)));
      } else if (openRounds && openRounds.resultDates) {
        roundsToFetch = [openRounds.resultDates[0]];
      }
    }
    this.set('date', roundsToFetch[0].date);
    this.set('rounds', roundsToFetch);
  },
  getResult(drawNumber) {
    const productName = this.get('productName');
    if (drawNumber.drawNumber) {
      drawNumber = drawNumber.drawNumber.map(number => ({
        product: productName,
        drawNumber: number
      }));
    }
    this.set('rounds', drawNumber);
  }
});

 })(window);